import { render } from "./ImobiliariasView.vue?vue&type=template&id=1340618a&scoped=true"
import script from "./ImobiliariasView.vue?vue&type=script&lang=js"
export * from "./ImobiliariasView.vue?vue&type=script&lang=js"

import "./ImobiliariasView.vue?vue&type=style&index=0&id=1340618a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\LAF\\Desktop\\GARANTEPAY\\PROJETOS\\WORKFLOW\\FrontVue-main\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1340618a"]])

export default __exports__